<template>
  <div class="spo-card pa-2 rounded">
    <div class="d-flex flex-column">
      <v-carousel class="thumbnail_carousel full-width" :show-arrows="false"
        :hide-delimiters="article.url_image_2 == '' && article.url_image_3 == ''" height="300" color="white"
        style="width: 100% !important; min-width: 200px">
        <v-carousel-item class="carousel-article-item" v-if="article.url_image != ''" :src="article.url_image"
          @click="zoom(article.url_image)" cover></v-carousel-item>
        <v-carousel-item class="carousel-article-item" v-if="article.url_image_2 != ''" :src="article.url_image_2"
          @click="zoom(article.url_image_2)" cover></v-carousel-item>
        <v-carousel-item class="carousel-article-item" v-if="article.url_image_3 != ''" :src="article.url_image_3"
          @click="zoom(article.url_image_3)" cover></v-carousel-item>

      </v-carousel>
      <div class="d-flex flex-column justify-start flex-wrap mt-2">
        <div class="text-h5 font-weight-bold">{{ article.nom }}</div>
        <div v-html="article.description"></div>
        <div class="text-body-1">
          <i>Disponible en: {{ list_tailles_text }}</i>
          <v-tooltip v-if="article.get_metadata('popup_info_supp_taille')">
            <u>Guide des tailles</u>
            <div v-html="article.get_metadata('popup_info_supp_taille')"></div>
            <template v-slot:activator="{ props }">
              <v-btn density="compact" size="small" class="ml-2" color="primary-dark" variant="elevated" elevation="1"
                v-bind="props" icon="mdi-help"></v-btn>
            </template>
          </v-tooltip>
        </div>

        <div class="text-h6 mt-3 font-weight-bold d-flex flex-column align-md-end align-center">
          <span v-if="parseInt(article.prix) > 0">{{ article.prix }}€</span><span v-else>Gratuit</span>
        </div>
        <div class="d-flex flex-column justify-start">
          <div v-if="mainStore.billetterie_mode" class="mb-3">
            <SportipsButton
              v-if="article.is_selectionnable(mainStore.module.status, mainStore.view_as_admin, mainStore.inscription_as_admin, mainStore?.inscription_vip?.is_valid(), mainStore.bookingSystem?.groupe)"
              @onClick="$router.push({ name: 'Inscriptions' })" icon="mdi-cart" chevron action-button full-width>
              Commander</SportipsButton>
            <div v-else
              class="d-flex align-center justify-center ga-1 bg-dark-red text-white rounded py-2 px-1 font-weight-600 cursor-disabled">
              <v-icon icon="mdi-pencil-off-outline"></v-icon>
              Indisponible
            </div>

          </div>
        </div>

      </div>
    </div>
    <v-dialog v-model="zoomDialog" width="auto" max-width="100%" height="auto" max-height="100%" scroll-strategy="none">
      <v-card class="pa-2">
        <v-img style="max-width:100%;width:800px;height:auto;margin:auto;" :src="zoomOn"></v-img>
        <v-btn @click="zoomDialog = false">Fermer</v-btn>
      </v-card>

    </v-dialog>

  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  props: ["article"],
  data() {
    return {
      zoomDialog: false,
      zoomOn: null,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_tailles_text() {
      let join = this.article.sizes.map((taille) => taille.nom).join(", ");
      return join != "" ? join : "Taille unique";
    },
  },
  methods: {
    zoom(url) {
      this.zoomOn = url;
      this.zoomDialog = true;
    }
  }
};
</script>

<style lang="scss">
.thumbnail_article {
  width: auto;
  height: 200px;
  border-radius: 5px;
}

.carousel-article-item img {
  cursor: zoom-in !important;
}
</style>